import Box from "@mui/material/Box";
import Sidebar from "./components/Layout/Sidebar";
import GeneralContainer from "./components/Layout/GeneralContainer";
import SlideChat from "./components/Layout/SlideChat";
import { FormProvider, useForm } from "react-hook-form";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatchApp, useSelectorApp } from "../../lib/redux";
import { useMediaQuery, useTheme } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  startGetAdsCampaign,
  startGetBrandInformation,
  startGetDraftCampaign,
  startGetRecommendedSettingsPlatform,
  startUpdateAdsCampaignsInformationFromPlatforms,
  startUpdateCampaignEntityStatus,
  checkAndAddPublishingCampaign,
  startGetCurrencyTax,
  startSaveAdsCampaignDraft,
  startListenerAdsCampaignActionStatus,
  stopListenerAdsCampaignActionStatus,
  checkAndShowNpsForm,
  checkAndSaveUserOnboardingChecklist,
} from "../../actions/adsCampaigns";
import { startGetCampaignAgentMessages } from "../../actions/chat";
import {
  normalizeCampaignApprovalState,
  startBumpCampaignApprovalDraft,
  startEnableCampaignApproval,
  startListenerCampaignApproval,
  stopListenerCampaignApproval,
} from "../../actions/campaignApproval";
import { deriveApprovalStatusFromReviewers } from "../../components/ContentApproval/approvalReviewersUtils";
import {
  ADS_CAMPAIGN_ENTITIES,
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ADS_CAMPAIGN_STATUS_FINISHED,
  ALERT_ICON_TYPE_SUCCESS,
  ALERT_ICON_TYPE_INFO,
  ALERTS_ASYNC_STATUS,
  ADS_CAMPAIGN_PLATFORMS_WITH_MIN_BUDGET_IN_USD,
  NPS_RATING_ACTION_CREATE,
  NPS_RATING_ACTION_ACTIVE_7_DAYS,
  NPS_RATING_ACTION_ACTIVE_30_DAYS,
  MIN_WIDTH_SCREEN_TO_SHOW_CHAT,
  CHECKLIST_CREATE_CAMPAIGN,
  ROUTE_CAMPAIGNS,
  ADS_CAMPAIGNS_DEMO,
} from "../../utils/constants";
import { useCreditActionCosts } from "../../hooks/useCreditActionCosts";
import { useRebrandBanner } from "../../hooks/useRebrandBanner";
import {
  getCurrencyAdAccountPlatform,
  getIsBlockedActions,
  getRoleCapability,
} from "../../actions/getters";
import Loader from "../../components/Loaders/Loader";
import {
  ADS_CAMPAIGN_HAS_BEEN_SAVE,
  ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN,
  ALERT_FILL_BRAND_SETUP_TITLE,
  ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION,
  BUTTON_COMPLETE_INFORMATION,
  CAMPAIGN_GENERATED_ERROR,
  CAMPAIGN_GENERATED_SUCCESS,
  CAMPAIGN_IS_GENERATING,
  GENERATING_CAMPAIGN,
  LOADING_INFORMATION,
  READY,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { getCampaignUpdatedByStatus } from "../../services/adsCampaigns";
import { ConfirmAlert, SimpleAlert } from "../../components/Alerts/Alerts";
import ApprovalEnableSuccessDialog from "../../components/ContentApproval/ApprovalEnableSuccessDialog";
import ModalErrorsCampaigns from "../AdsCampaign/components/ModalErrorsCampaigns";
import { zodResolver } from "@hookform/resolvers/zod";
import { getCampaignSchema } from "./utils/schemas/campaignSchema";
import { CAMPAIGN_FORM_ZOD_PARAMS } from "./utils/schemas/campaignFormZod";
import { getCampaignLocationsFromEntities } from "./utils/campaignLocations";
import { useUploadAsyncContentInCampaign } from "./hooks/useUploadAsyncContentInCampaign";
import i18next from "i18next";
import _ from "lodash";
import { Helmet } from "react-helmet";
import {
  consumePendingIntegrationFormSyncForCampaign,
  updateNotification,
} from "../../actions/alerts";
import { closeCreativeNotification } from "../../actions/creativeJobs";
import { CREATIVE_JOB_TYPES } from "../../utils/errors";
import FloatingValidationErrorsPanel from "./components/Common/FloatingValidationErrorsPanel";
import {
  getCreativeOptimizationSlotKey,
  getFormPathForCreativeSlot,
} from "../../utils/creativeOptimizationContext";
import {
  findAdsGroupIndexById,
  isAdPresentInAdsGroups,
  toAdsGroupsList,
  withAdsGroupsList,
} from "../../utils/adsGroupsList";
import SlideMenu from "../../components/Menus/SlideMenu";
import { consumeJustImportedCampaign } from "../../utils/importedCampaignAlert";
import { buildOptimisticSwitchCopy } from "../../optimisticSwitch/copy";
import { OPTIMISTIC_SWITCH_KIND } from "../../optimisticSwitch/kinds";
import {
  createOptimisticSwitchOperationId,
  reportOptimisticSwitchFailure,
  toOptimisticSwitchPayload,
} from "../../optimisticSwitch/runOptimisticSwitch";
import {
  buildCreateCampaignEditorUrl,
  buildCreateCampaignListUrl,
  consumePendingInitialGenerationState,
} from "../../components/Modal/ModalCreateAdsCampaign/createAdsCampaignWizardUtils";
import CampaignApprovalPanel from "./components/CampaignApproval/CampaignApprovalPanel";
import { ApprovalCommentFieldHintProvider } from "./components/CampaignApproval/approvalCommentFieldHintContext";

import { LaunchError } from "../../utils/errors";

const EMPTY_PLATFORMS = [];
const EMPTY_LOCATIONS = { contexts: [], locations: [] };
const RETRY_JOB_ID_QUERY_PARAM = "retryJobID";

const isGeneratingCampaignErrorNotification = (notification, campaignID) =>
  notification?.type === "campaign" &&
  notification.campaignID === campaignID &&
  notification.jobType ===
    CREATIVE_JOB_TYPES.generateRecommendedSettingsPlatform &&
  notification.status === ALERTS_ASYNC_STATUS.ERROR;

const dismissGeneratingCampaignErrors = (
  dispatch,
  notifications,
  campaignID
) => {
  notifications
    .filter((notification) =>
      isGeneratingCampaignErrorNotification(notification, campaignID)
    )
    .forEach((notification) => {
      dispatch(closeCreativeNotification(notification.id));
    });
};

const getOptimisticSwitchKindFromTarget = (target) => {
  switch (target) {
    case ADS_CAMPAIGN_ENTITIES.ASSETS_GROUP:
    case "assetsGroup":
      return OPTIMISTIC_SWITCH_KIND.ASSETS_GROUP;
    case ADS_CAMPAIGN_ENTITIES.AD_GROUP:
    case "adGroup":
      return OPTIMISTIC_SWITCH_KIND.AD_GROUP;
    case ADS_CAMPAIGN_ENTITIES.AD:
    case "ad":
      return OPTIMISTIC_SWITCH_KIND.AD;
    default:
      return OPTIMISTIC_SWITCH_KIND.CAMPAIGN;
  }
};

const getOptimisticSwitchEntityName = ({
  values,
  target,
  platform,
  assetsGroupID,
  adGroupID,
  adID,
}) => {
  switch (target) {
    case ADS_CAMPAIGN_ENTITIES.ASSETS_GROUP:
    case "assetsGroup":
      return values?.assetsGroups?.[assetsGroupID]?.name || "";
    case ADS_CAMPAIGN_ENTITIES.AD_GROUP:
    case "adGroup":
      return values?.adsGroups?.[adGroupID]?.name || "";
    case ADS_CAMPAIGN_ENTITIES.AD:
    case "ad":
      return values?.adsGroups?.[adGroupID]?.ads?.[adID]?.name || "";
    default:
      return (
        values?.platformsData?.[platform]?.name ||
        values?.platforms?.[0] ||
        values?.name ||
        ""
      );
  }
};

const hasCampaignLocations = (locations) =>
  Boolean(locations?.locations?.length || locations?.contexts?.length);

const resolveCampaignSetupFields = (...sources) => {
  let context = "";
  let language = "";
  let locations;

  sources.forEach((source) => {
    if (!source) {
      return;
    }
    if (!context && source.context) {
      context = source.context;
    }
    if (!language && source.language) {
      language = source.language;
    }
    if (!hasCampaignLocations(locations) && source.locations) {
      locations = source.locations;
    }
  });

  // Campaign locations empty (e.g. campaigns generated in bulk): when adding
  // a platform, feed them from the locations of the existing entities.
  if (!hasCampaignLocations(locations)) {
    locations = getCampaignLocationsFromEntities(sources[0]) || locations;
  }

  return {
    context,
    language,
    locations: locations || EMPTY_LOCATIONS,
  };
};

const NewAdsCampaign = () => {
  const { totalTopOffsetPx } = useRebrandBanner();
  const [adsCampaignActionStatusListener, setAdsCampaignActionStatusListener] =
    useState(null);
  const [campaignActionLock, setCampaignActionLock] = useState(null);
  const [campaignActionStatus, setCampaignActionStatus] = useState(null);
  const [currencyTaxes, setCurrencyTaxes] = useState(null);
  const [schema, setSchema] = useState(null);
  const [isForcedSetupPage, setIsForcedSetupPage] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [pendingAgentChangesCount, setPendingAgentChangesCount] = useState(0);
  const [sectionSelected, setSectionSelected] = useState({
    platform: undefined,
    assetsGroupID: undefined,
    adGroupID: undefined,
    adID: undefined,
  });
  const [isSyncingData, setIsSyncingData] = useState(false);
  const [platformGenerating, setPlatformGenerating] = useState(null);
  const [lastInformationToGenerate, setLastInformationToGenerate] = useState(
    {}
  );
  const [optimizations, setOptimizations] = useState([]);
  const [creativeOptimizations, setCreativeOptimizations] = useState({});
  const [showErrorGenerating, setShowErrorGenerating] = useState(false);
  const [modalErrorsCampaignsOpen, setModalErrorsCampaignsOpen] =
    useState(false);
  const [dataModalErrorsCampaigns, setDataModalErrorsCampaigns] = useState({});
  const [campaignID, setCampaignID] = useState(null);
  const [brandInformation, setBrandInformation] = useState({});
  const [statistics, setStatistics] = useState({});
  const [isLoadingStatistics, setIsLoadingStatistics] = useState(false);
  const [previewsCached, setPreviewsCached] = useState({});
  const [audiencePreviewsCache, setAudiencePreviewsCache] = useState({});
  const [chatMessages, setChatMessages] = useState({});
  const [hasMoreChatMessages, setHasMoreChatMessages] = useState(false);
  const [isLoadingChatMessages, setIsLoadingChatMessages] = useState(() =>
    Boolean(new URLSearchParams(window.location.search).get("campaignID"))
  );
  const [shouldOpenChat, setShouldOpenChat] = useState(false);
  const [isPlatformClicked, setIsPlatformClicked] = useState(false);
  const [campaignApproval, setCampaignApproval] = useState(
    normalizeCampaignApprovalState(null)
  );
  const [isEnablingCampaignApproval, setIsEnablingCampaignApproval] =
    useState(false);
  const [campaignApprovalListener, setCampaignApprovalListener] =
    useState(null);
  const [isApprovalCommentsPanelOpen, setIsApprovalCommentsPanelOpen] =
    useState(false);
  const [approvalSuccessDialog, setApprovalSuccessDialog] = useState({
    open: false,
    approvalUrl: "",
    reviewerID: "",
  });

  const clearPreloadedChatMessagesRef = useRef(null);
  const lastInitialLoadCampaignIDRef = useRef(null);
  const pendingInitialGenerationRef = useRef(null);
  const generateCampaignPlatformRef = useRef(null);
  const keepGenerationErrorViewRef = useRef(false);
  const previousCampaignIDParamRef = useRef(null);
  const previousApprovalStatusRef = useRef(campaignApproval?.status);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const platform = searchParams.get("platform");

  const methodsDateFilters = useForm({
    defaultValues: {
      datePreset: "",
      dateRange: {
        startDateTime: "",
        endDateTime: "",
      },
    },
  });

  const methods = useForm({
    resolver: zodResolver(schema, CAMPAIGN_FORM_ZOD_PARAMS),
    defaultValues: {
      context: "",
      language: "",
      locations: {
        contexts: [],
        locations: [],
      },
      platforms: [],
      adsGroups: [],
    },
    shouldUnregister: false,
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const { getValues, setValue, watch, reset } = methods;
  const generatedPlatforms = watch("generatedPlatforms") || {};

  const onUpsertCreativeOptimization = useCallback((entry) => {
    const { title, action, field, formPath } = entry || {};
    if (!title || !action || !field || !formPath) return;
    const slotKey = getCreativeOptimizationSlotKey({
      formPath,
      field,
    });
    setCreativeOptimizations((prev) => ({
      ...prev,
      [slotKey]: { ...entry, slotKey },
    }));
  }, []);

  const onRemoveCreativeOptimization = useCallback((slotKey) => {
    setCreativeOptimizations((prev) => {
      if (!(slotKey in prev)) return prev;
      const next = { ...prev };
      delete next[slotKey];
      return next;
    });
  }, []);

  const dispatch = useDispatchApp();
  const navigate = useNavigate();
  const [params, setSearchParams] = useSearchParams();
  const { t } = useTranslationApp();
  const { ADS_CAMPAIGN_GENERATE_CAMPAIGN_ACTION } = useCreditActionCosts();
  const muiTheme = useTheme();
  const isLargeScreen = useMediaQuery(
    muiTheme.breakpoints.up(MIN_WIDTH_SCREEN_TO_SHOW_CHAT)
  );
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));

  const campaignIDParam = params.get("campaignID");
  const retryJobIDParam = params.get(RETRY_JOB_ID_QUERY_PARAM);
  const [retryJobID, setRetryJobID] = useState(retryJobIDParam);
  const [dismissGeneratingCampaignError, setDismissGeneratingCampaignError] =
    useState(Boolean(retryJobIDParam));
  const generationErrorCheckedCampaignRef = useRef(null);
  const platformParam = params.get("platform");
  const assetsGroupIDParam = params.get("assetsGroupID");
  const adGroupIDParam = params.get("adGroupID");
  const adIDParam = params.get("adID");
  const shouldOpenChatParam = params.get("openChat") === "1";
  const doSyncParam = params.get("doSync");
  const doSync = doSyncParam ? doSyncParam === "true" : true;
  const showDraftParam = params.get("showDraft");
  const showDraft = showDraftParam ? showDraftParam === "true" : false;
  const integrations = useSelectorApp((state) => state?.user?.integrations);
  const { theme } = useSelectorApp((state) => state.ui);
  const pendingIntegrationFormSync = useSelectorApp(
    (state) => state?.alerts?.pendingIntegrationFormSync
  );
  const notifications = useSelectorApp(
    (state) => state.alerts?.notifications || []
  );

  const startSaveAdsCampaignWithApproval = useCallback(
    ({ campaign, campaignID: targetCampaignID, shouldBumpApproval = true }) =>
      async (dispatchInternal) => {
        const isSaved = await dispatchInternal(
          startSaveAdsCampaignDraft({
            campaign,
            campaignID: targetCampaignID,
          })
        );

        if (
          isSaved &&
          shouldBumpApproval &&
          targetCampaignID === campaignID &&
          campaignApproval?.enabled
        ) {
          await dispatchInternal(
            startBumpCampaignApprovalDraft({
              campaignID: targetCampaignID,
            })
          );
        }

        return isSaved;
      },
    [campaignApproval?.enabled, campaignID]
  );

  const onEnableCampaignApproval = async () => {
    if (!campaignID) {
      return false;
    }

    setIsEnablingCampaignApproval(true);
    const response = await dispatch(
      startEnableCampaignApproval({ campaignID })
    );
    setIsEnablingCampaignApproval(false);

    if (response?.ok && response?.url) {
      setApprovalSuccessDialog({
        open: true,
        approvalUrl: response.url,
        reviewerID: response.reviewerID || "",
      });
    }

    return response;
  };

  const onCopyCampaignApprovalLink = () => {
    const approvalUrl = campaignApproval?.url;
    if (!approvalUrl || !navigator?.clipboard?.writeText) {
      return;
    }

    navigator.clipboard.writeText(approvalUrl).catch(() => {});
    SimpleAlert({
      title: t(READY),
      icon: ALERT_ICON_TYPE_SUCCESS,
    });
  };

  const onOpenCampaignApprovalCommentsPanel = () => {
    setIsApprovalCommentsPanelOpen(true);
  };

  useUploadAsyncContentInCampaign({
    campaignID,
    getValues,
    setValue,
    watch,
  });

  const states = watch("states") || {};
  const rawPlatforms = watch("platforms");
  const platforms = rawPlatforms ?? EMPTY_PLATFORMS;
  const platformsDepKey = Array.isArray(rawPlatforms)
    ? rawPlatforms.join("|")
    : "";
  const platformIDs = watch("platformIDs") || [];
  const hasSomePlatformDraft = Object.keys(states || {}).some(
    (key) => states[key] === ADS_CAMPAIGN_STATUS_DRAFT
  );
  const hasSomePlatformCreated = Object.keys(states || {}).some(
    (key) => states[key] !== ADS_CAMPAIGN_STATUS_DRAFT
  );
  const isViewOnboarding =
    !platform ||
    platform === "undefined" ||
    isForcedSetupPage ||
    platforms.length === 0;

  useEffect(() => {
    if (retryJobIDParam) {
      setDismissGeneratingCampaignError(true);
      setRetryJobID(retryJobIDParam);
      const nextParams = new URLSearchParams(params);
      nextParams.delete(RETRY_JOB_ID_QUERY_PARAM);
      setSearchParams(nextParams, { replace: true });
    } else if (previousCampaignIDParamRef.current !== campaignIDParam) {
      setRetryJobID(null);
      keepGenerationErrorViewRef.current = false;
      setShowErrorGenerating(false);
      generationErrorCheckedCampaignRef.current = null;
    }
    previousCampaignIDParamRef.current = campaignIDParam;
  }, [campaignIDParam, retryJobIDParam, params, setSearchParams]);

  useEffect(() => {
    if (!campaignID || !retryJobID) {
      return;
    }

    const matchingGenerationNotifications = notifications.filter(
      (notification) =>
        notification.campaignID === campaignID &&
        notification.type === "campaign" &&
        notification.jobType ===
          CREATIVE_JOB_TYPES.generateRecommendedSettingsPlatform
    );
    const hasInProgressGeneration = matchingGenerationNotifications.some(
      (notification) =>
        notification.status === ALERTS_ASYNC_STATUS.LOADING ||
        notification.status === ALERTS_ASYNC_STATUS.GENERATING ||
        notification.isGenerating
    );
    const failedGenerationNotification = matchingGenerationNotifications.find(
      (notification) =>
        notification.status === ALERTS_ASYNC_STATUS.ERROR &&
        (notification.jobID === retryJobID || notification.id === retryJobID)
    );

    if (platformGenerating || hasInProgressGeneration) {
      return;
    }

    if (!failedGenerationNotification) {
      return;
    }

    const isAddPlatformFailure =
      failedGenerationNotification.buttonAction === "addPlatform" ||
      (platforms.length > 0 &&
        failedGenerationNotification.buttonAction !== "generateInitial");

    if (platforms.length > 0 && !isAddPlatformFailure) {
      return;
    }

    const setupFields = resolveCampaignSetupFields(
      failedGenerationNotification.platformGeneratingData,
      failedGenerationNotification.currentCampaign
    );

    if (setupFields.context) {
      setValue("context", setupFields.context);
    }
    if (setupFields.language) {
      setValue("language", setupFields.language);
    }
    if (hasCampaignLocations(setupFields.locations)) {
      setValue("locations", setupFields.locations);
    }

    const restoredPlatformData = {
      ...setupFields,
      ...(failedGenerationNotification.platformGeneratingData || {}),
      buttonAction: isAddPlatformFailure
        ? "addPlatform"
        : failedGenerationNotification.buttonAction || "generateInitial",
    };

    keepGenerationErrorViewRef.current = true;
    setLastInformationToGenerate(restoredPlatformData);
    if (isAddPlatformFailure) {
      setIsForcedSetupPage(true);
    }
    setShowErrorGenerating(true);
  }, [
    campaignID,
    notifications,
    platforms.length,
    platformGenerating,
    dismissGeneratingCampaignError,
    retryJobID,
    setValue,
  ]);

  useEffect(() => {
    if (!campaignID) {
      return;
    }

    if (dismissGeneratingCampaignError) {
      if (!retryJobID) {
        return;
      }
      setDismissGeneratingCampaignError(false);
      generationErrorCheckedCampaignRef.current = campaignID;
      dismissGeneratingCampaignErrors(dispatch, notifications, campaignID);
      return;
    }

    if (generationErrorCheckedCampaignRef.current === campaignID) {
      return;
    }

    generationErrorCheckedCampaignRef.current = campaignID;
    dismissGeneratingCampaignErrors(dispatch, notifications, campaignID);
  }, [
    campaignID,
    dismissGeneratingCampaignError,
    dispatch,
    notifications,
    retryJobID,
  ]);

  const onGenerateCampaignPlatform = async (platformData) => {
    const formValues = getValues();
    const currentPlatforms = formValues.platforms || [];
    const setupFields = resolveCampaignSetupFields(
      formValues,
      platformData,
      lastInformationToGenerate
    );
    const campaignValues = {
      ...formValues,
      ...setupFields,
    };
    const platformGeneratingData = {
      ...platformData,
      ...setupFields,
    };
    const buttonAction =
      currentPlatforms.length > 0 ||
      platformData.buttonAction === "addPlatform" ||
      lastInformationToGenerate.buttonAction === "addPlatform"
        ? "addPlatform"
        : isViewOnboarding
          ? "generateInitial"
          : "addPlatform";

    const sourceFailedJobID = retryJobID;
    keepGenerationErrorViewRef.current = false;
    setShowErrorGenerating(false);
    if (sourceFailedJobID) {
      dispatch(closeCreativeNotification(sourceFailedJobID));
      setRetryJobID(null);
    }
    const newPlatforms = [...currentPlatforms, platformData.platform];
    setLastInformationToGenerate({
      ...platformGeneratingData,
      buttonAction,
    });

    if (isForcedSetupPage) {
      setIsForcedSetupPage(false);
    }

    setPlatformGenerating(platformData.platform);
    dispatch(
      checkAndAddPublishingCampaign({
        campaignID,
        isCreating: false,
        isGenerating: true,
        status: ALERTS_ASYNC_STATUS.GENERATING,
        message: t(GENERATING_CAMPAIGN),
        progress: 0,
        platformGeneratingData,
        currentCampaign: campaignValues,
        newPlatforms: newPlatforms,
        buttonAction,
        platform: platformData.platform,
      })
    );

    if (!isViewOnboarding) {
      const campaign = getValues();
      await dispatch(
        startSaveAdsCampaignWithApproval({
          campaign,
          campaignID,
        })
      );
    }
    onChangeSectionSelected({
      platform: undefined,
      assetsGroupID: undefined,
      adGroupID: undefined,
      adID: undefined,
    });
    const response = await dispatch(
      startGetRecommendedSettingsPlatform({
        ...platformData,
        ...campaignValues,
        platforms: newPlatforms,
        campaignID,
        platformGeneratingData,
        currentCampaign: campaignValues,
        buttonAction,
      })
    );
    const notificationID = response.jobID || campaignID;
    if (response.ok) {
      setRetryJobID(null);
      keepGenerationErrorViewRef.current = false;
      setShowErrorGenerating(false);
      const data = response.data;
      reset(withAdsGroupsList(data));

      if (isViewOnboarding) {
        onChangeSectionSelected({
          platform: platformData.platform,
          assetsGroupID: undefined,
          adGroupID: undefined,
          adID: undefined,
        });
      }
      if (!isViewOnboarding) {
        dispatch(
          updateNotification(notificationID, {
            status: ALERTS_ASYNC_STATUS.SUCCESS,
            message: t(CAMPAIGN_GENERATED_SUCCESS),
            isCreating: false,
            isGenerating: false,
          })
        );
      }

      dispatch(checkAndShowNpsForm(NPS_RATING_ACTION_CREATE));
      dispatch(checkAndSaveUserOnboardingChecklist(CHECKLIST_CREATE_CAMPAIGN));
    } else {
      setShowErrorGenerating(true);
      if (response.jobID) {
        setRetryJobID(response.jobID);
      }
      if (buttonAction === "addPlatform") {
        keepGenerationErrorViewRef.current = true;
        setIsForcedSetupPage(true);
      }

      dispatch(
        updateNotification(notificationID, {
          status: ALERTS_ASYNC_STATUS.ERROR,
          message: t(CAMPAIGN_GENERATED_ERROR),
          isCreating: false,
          isGenerating: false,
          jobType: CREATIVE_JOB_TYPES.generateRecommendedSettingsPlatform,
          buttonAction,
        })
      );

      if (!isViewOnboarding && response.code === CAMPAIGN_IS_GENERATING) {
        navigate(ROUTE_CAMPAIGNS, {
          replace: true,
        });
      }
    }
    setPlatformGenerating(null);
  };
  generateCampaignPlatformRef.current = onGenerateCampaignPlatform;

  const onSetDataCampaign = (data, changeSection = true) => {
    reset(withAdsGroupsList(data));
    if (changeSection && !keepGenerationErrorViewRef.current) {
      // Replace the entry created by the table link. A push here leaves Back
      // on the editor, and a later param sync pushes platform again.
      onChangeSectionSelected({
        platform: platformParam || data?.platforms?.[0],
        assetsGroupID: assetsGroupIDParam || undefined,
        adGroupID: adGroupIDParam || undefined,
        adID: adIDParam || undefined,
        replaceSearch: true,
      });
    }
  };

  const onUpdateAdsCampaignInformationFromPlatforms = async (
    campaignID,
    data
  ) => {
    setIsSyncingData(true);
    setIsLoading(false);
    await onLoadChatMessages(campaignID);
    const response = await dispatch(
      startUpdateAdsCampaignsInformationFromPlatforms({
        campaignID,
      })
    );
    if (response.ok) {
      const updatedData = response?.data?.campaign;
      const currentURLCampaign = new URLSearchParams(
        window.location.search
      ).get("campaignID");
      const isStale = campaignID !== currentURLCampaign;
      if (isStale) {
        setIsSyncingData(false);
        return;
      }
      onSetDataCampaign(updatedData, true);
      onUpdateCurrencyTaxPlatforms(updatedData?.platformsData);
    } else {
      const currentURLCampaign = new URLSearchParams(
        window.location.search
      ).get("campaignID");
      const isStale = campaignID !== currentURLCampaign;
      if (isStale) {
        setIsSyncingData(false);
        return;
      }
      onSetDataCampaign(data, false);
      const currentData = getValues();
      onUpdateCurrencyTaxPlatforms(currentData?.platformsData);
    }

    setIsSyncingData(false);
    reset(getValues());

    return response;
  };

  const onListenerAdsCampaignActionStatus = async (campaignID) => {
    if (adsCampaignActionStatusListener) {
      await dispatch(
        stopListenerAdsCampaignActionStatus(adsCampaignActionStatusListener)
      );
    }
    dispatch(
      startListenerAdsCampaignActionStatus({
        campaignID,
        onReferenceAvailable: (listener) =>
          setAdsCampaignActionStatusListener(listener),
        onUpdatedDataCallback: (lock) => {
          setCampaignActionLock(lock);
        },
      })
    );
  };

  const onVerifyHasCampaignToCreate = async () => {
    const isBlocked = await dispatch(
      getIsBlockedActions({
        action: ADS_CAMPAIGN_GENERATE_CAMPAIGN_ACTION,
        showUsageConfirmationAlert: false,
      })
    );
    if (isBlocked) {
      navigate(ROUTE_CAMPAIGNS);
    }
    return isBlocked;
  };

  const shouldShowNpsForActiveCampaign = (campaignData) => {
    if (!campaignData?.firstActiveTime || !campaignData?.states?.general) {
      return null;
    }

    const isActive = campaignData.states.general === ADS_CAMPAIGN_STATUS_ACTIVE;
    if (!isActive) {
      return null;
    }

    const firstActiveTime = campaignData.firstActiveTime;
    const now = new Date().getTime();
    const daysSinceFirstActive = Math.floor(
      (now - firstActiveTime) / (1000 * 60 * 60 * 24)
    );

    if (daysSinceFirstActive >= 30) {
      return NPS_RATING_ACTION_ACTIVE_30_DAYS;
    } else if (daysSinceFirstActive >= 7) {
      return NPS_RATING_ACTION_ACTIVE_7_DAYS;
    }

    return null;
  };

  const maybeShowImportedCampaignInfoAlert = (campaignID, isImported) => {
    if (!isImported || consumeJustImportedCampaign(campaignID)) {
      return;
    }

    SimpleAlert({
      text: t(ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION),
      icon: ALERT_ICON_TYPE_INFO,
    });
  };

  const onGetInitialData = async (campaignID) => {
    setIsLoading(true);
    onListenerAdsCampaignActionStatus(campaignID);
    const response = await dispatch(startGetAdsCampaign(campaignID));
    if (response) {
      getBrandInformation(false);

      const data = response;

      const npsActionType = shouldShowNpsForActiveCampaign(data);
      if (npsActionType) {
        dispatch(checkAndShowNpsForm(npsActionType));
      }

      if (data?.generatedPlatforms) {
        setValue("generatedPlatforms", data.generatedPlatforms);
      }

      maybeShowImportedCampaignInfoAlert(campaignID, data?.isImported);

      const hasSomePlatformCreated = Object.keys(response.states || {}).some(
        (key) => response.states[key] !== ADS_CAMPAIGN_STATUS_DRAFT
      );
      if (hasSomePlatformCreated && doSync) {
        onUpdateAdsCampaignInformationFromPlatforms(campaignID, data);
        onSetDataCampaign(data);
      } else {
        if (showDraft) {
          const responseDraft = await dispatch(
            startGetDraftCampaign({ campaignID })
          );
          if (responseDraft.ok) {
            const dataDraft = responseDraft.data;
            onSetDataCampaign(dataDraft);
            setIsLoading(false);
            onUpdateCurrencyTaxPlatforms(dataDraft?.platformsData);
          } else {
            onSetDataCampaign(data);
            setIsLoading(false);
            onUpdateCurrencyTaxPlatforms(data?.platformsData);
          }
        } else {
          onSetDataCampaign(data);
          setIsLoading(false);
          onUpdateCurrencyTaxPlatforms(data?.platformsData);
        }

        // Load chat before showing SlideChat so the opening auto-prompt does not race ahead.
        if (campaignIDParam) {
          await onLoadChatMessages(campaignIDParam);
        }
      }
    } else {
      setIsLoading(false);
      setIsLoadingChatMessages(false);
      getBrandInformation();
      onVerifyHasCampaignToCreate();
    }

    if (params.has("doSync") || params.has("showDraft")) {
      const nextParams = new URLSearchParams(params);
      nextParams.delete("doSync");
      nextParams.delete("showDraft");
      setSearchParams(nextParams);
    }
  };

  const getBrandInformation = async (isNewCampaign = true) => {
    const response = await dispatch(startGetBrandInformation());
    const hasBrandContext = Boolean(
      response?.data?.businessName && response?.data?.businessDescription
    );

    if (!hasBrandContext && isNewCampaign) {
      ConfirmAlert({
        title: t(ALERT_FILL_BRAND_SETUP_TITLE),
        text: t(ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN),
        confirmButtonText: t(BUTTON_COMPLETE_INFORMATION),
        showCancelButton: false,
      });
      navigate("/settings");
      return;
    }
    if (response.ok) {
      const { data } = response;
      setBrandInformation(data);
    }
  };

  const onChangeStatusCampaign = async ({
    newStatus,
    target = "campaign",
    platform,
    assetsGroupID,
    adGroupID,
    adID,
    showAlertSave = false,
    skipOptimisticSwitch = false,
  }) => {
    const currentCampaign = _.cloneDeep(getValues());
    const shouldUseOptimisticSwitch = skipOptimisticSwitch !== true;
    const copy = shouldUseOptimisticSwitch
      ? buildOptimisticSwitchCopy({
          t,
          kind: getOptimisticSwitchKindFromTarget(target),
          name: getOptimisticSwitchEntityName({
            values: currentCampaign,
            target,
            platform,
            assetsGroupID,
            adGroupID,
            adID,
          }),
          activate: newStatus === ADS_CAMPAIGN_STATUS_ACTIVE,
        })
      : null;
    const operationId = shouldUseOptimisticSwitch
      ? createOptimisticSwitchOperationId()
      : "";

    const objectUpdate = getCampaignUpdatedByStatus({
      campaign: getValues(),
      status: newStatus,
      target,
      platform,
      adGroupID,
      adID,
      assetsGroupID,
    });

    reset(objectUpdate);

    let entityID = "";

    if (target === ADS_CAMPAIGN_ENTITIES.PLATFORM) {
      entityID = campaignID;
      const platforms = Object.keys(currentCampaign?.platformIDs || {});
      if (platforms.length === 1) {
        target = ADS_CAMPAIGN_ENTITIES.ALL_CAMPAIGNS;
      }
    }
    if (target === ADS_CAMPAIGN_ENTITIES.ASSETS_GROUP) {
      const id = getValues(`assetsGroups.[${assetsGroupID}].id`);
      entityID = id;
    }
    if (target === ADS_CAMPAIGN_ENTITIES.AD_GROUP) {
      const id = getValues(`adsGroups.[${adGroupID}].id`);
      entityID = id;
    }
    if (target === ADS_CAMPAIGN_ENTITIES.AD) {
      const id = getValues(`adsGroups.[${adGroupID}].ads.[${adID}].id`);
      entityID = id;
    }

    const response = await dispatch(
      startUpdateCampaignEntityStatus({
        campaignID,
        platform,
        entity: target,
        entityID,
        status: newStatus,
        optimisticSwitch: shouldUseOptimisticSwitch
          ? toOptimisticSwitchPayload({ operationId, copy })
          : undefined,
        showErrorAlert: false,
      })
    );

    if (!response.ok) {
      reset(currentCampaign);
      if (shouldUseOptimisticSwitch) {
        reportOptimisticSwitchFailure({
          operationId,
          copy,
          error: response.error,
        });
      }
      return false;
    }

    if (response.reportCleared) {
      clearPreloadedChatMessagesRef.current?.();
      setOptimizations([]);
      setValue("report", {});
    }

    if (showAlertSave) {
      SimpleAlert({
        title: t(ADS_CAMPAIGN_HAS_BEEN_SAVE),
        icon: ALERT_ICON_TYPE_SUCCESS,
      });
    }

    return true;
  };

  const onChangeSectionSelected = (section) => {
    const {
      from,
      customParams,
      creativeOptimization: creativeOptimizationPayload,
      replaceSearch = false,
      ...rest
    } = section;
    if (
      isForcedSetupPage &&
      from !== "addPlatforms" &&
      !keepGenerationErrorViewRef.current
    ) {
      setIsForcedSetupPage(false);
    }

    const restCopy = { ...rest };

    const platforms = getValues("platforms") || [];
    const platformIsPresent = platforms.includes(rest.platform);
    const assetsGroups = getValues("assetsGroups");
    const assetsGroupIsPresent =
      platformIsPresent && rest?.assetsGroupID
        ? assetsGroups?.some(
            (assetsGroup) => assetsGroup?.id === rest?.assetsGroupID
          )
        : false;
    const adsGroups = toAdsGroupsList(getValues("adsGroups"));
    const adGroupIsPresent =
      platformIsPresent && rest?.adGroupID
        ? findAdsGroupIndexById({
            adsGroups,
            adGroupID: rest.adGroupID,
          }) >= 0
        : false;
    const adIsPresent =
      platformIsPresent && rest?.adGroupID && rest?.adID
        ? isAdPresentInAdsGroups({
            adsGroups,
            adGroupID: rest.adGroupID,
            adID: rest.adID,
          })
        : false;

    if (platformIsPresent) {
      params.set("platform", rest.platform);
    } else {
      params.set("platform", platforms[0]);
      restCopy.platform = platforms[0];
    }

    if (assetsGroupIsPresent) {
      params.set("assetsGroupID", rest.assetsGroupID);
    } else {
      params.delete("assetsGroupID");
      restCopy.assetsGroupID = undefined;
    }

    if (adGroupIsPresent) {
      params.set("adGroupID", rest.adGroupID);
    } else {
      params.delete("adGroupID");
      restCopy.adGroupID = undefined;
    }

    if (adIsPresent) {
      params.set("adID", rest.adID);
    } else {
      params.delete("adID");
      restCopy.adID = undefined;
    }

    if (
      creativeOptimizationPayload?.title &&
      creativeOptimizationPayload?.action &&
      creativeOptimizationPayload?.field &&
      creativeOptimizationPayload?.formPath
    ) {
      onUpsertCreativeOptimization(creativeOptimizationPayload);
    }

    const titleFromUrl = params.get("title");
    const actionFromUrl = params.get("action");
    const fieldFromUrl = params.get("field");
    if (titleFromUrl && actionFromUrl && fieldFromUrl) {
      const formPathFromUrl = getFormPathForCreativeSlot({
        getValues,
        adGroupID: restCopy.adGroupID,
        adID: restCopy.adID,
        assetsGroupID: restCopy.assetsGroupID,
      });
      if (formPathFromUrl) {
        onUpsertCreativeOptimization({
          title: titleFromUrl,
          action: actionFromUrl,
          field: fieldFromUrl,
          formPath: formPathFromUrl,
        });
      }
    }

    if (customParams) {
      Object.keys(customParams || {}).forEach((key) => {
        if (_.isUndefined(customParams[key])) {
          params.delete(key);
          return;
        }
        params.set(key, customParams[key]);
      });
    }
    setSearchParams(params, replaceSearch ? { replace: true } : undefined);
    setSectionSelected(restCopy);
  };

  const onLoadChatMessages = async (campaignIDToUse = campaignID) => {
    setIsLoadingChatMessages(true);
    try {
      const isDemoCampaign = ADS_CAMPAIGNS_DEMO.includes(campaignIDToUse);
      const persistedResponse = isDemoCampaign
        ? { ok: false, data: {} }
        : await dispatch(
            startGetCampaignAgentMessages({ campaignID: campaignIDToUse })
          );
      const messages = persistedResponse.ok ? persistedResponse.data || {} : {};

      setHasMoreChatMessages(Boolean(persistedResponse.hasMore));

      if (Object.keys(messages).length > 0) {
        setChatMessages(messages);
        if (shouldOpenChatParam) {
          setShouldOpenChat(true);
        }
      }

      if (shouldOpenChatParam) {
        params.delete("openChat");
        setSearchParams(params);
      }
    } catch (error) {
      dispatch(
        LaunchError(error, false, [], {
          functionName: "onLoadChatMessages",
          capture: "exception",
        })
      );
      console.error("Error loading chat messages:", error);
    } finally {
      setIsLoadingChatMessages(false);
    }
  };

  const onLoadOlderChatMessages = ({ endBeforeTime }) =>
    dispatch(
      startGetCampaignAgentMessages({
        campaignID: new URLSearchParams(window.location.search).get(
          "campaignID"
        ),
        endBeforeTime,
      })
    );

  const onUpdateCurrencyTaxPlatforms = async (platformsData) => {
    const platformsWithData = Object.keys(platformsData || {});
    const currenciesData = {};

    for (const platform of platformsWithData) {
      if (!ADS_CAMPAIGN_PLATFORMS_WITH_MIN_BUDGET_IN_USD.includes(platform)) {
        continue;
      }
      const platformData = platformsData?.[platform];
      if (!platformData) continue;

      const currency = dispatch(
        getCurrencyAdAccountPlatform({
          platform,
          integrationID: platformData?.integrationID,
          adAccountID: platformData?.adAccountID,
        })
      );

      if (!currency) {
        continue;
      }

      if (currenciesData[currency] || currencyTaxes?.[currency] != null) {
        continue;
      }

      const response = await dispatch(startGetCurrencyTax(currency));
      if (response.ok) {
        currenciesData[currency] = response.data;
      }
    }

    setCurrencyTaxes((prev) => ({
      ...(prev || {}),
      ...currenciesData,
    }));
  };

  const onGetItemSelectedLevel = ({
    platform,
    assetsGroupID,
    adGroupID,
    adID,
  }) => {
    if (!platform) return null;
    if (typeof assetsGroupID === "string") {
      return ADS_CAMPAIGN_ENTITIES.ASSETS_GROUP;
    }
    if (typeof adGroupID === "string") {
      return typeof adID === "string"
        ? ADS_CAMPAIGN_ENTITIES.AD
        : ADS_CAMPAIGN_ENTITIES.AD_GROUP;
    }
    return ADS_CAMPAIGN_ENTITIES.PLATFORM;
  };

  const getIsCampaignPlatformActive = (platform) => {
    const state = states?.[platform];
    return (
      state === ADS_CAMPAIGN_STATUS_ACTIVE ||
      state === ADS_CAMPAIGN_STATUS_FINISHED
    );
  };
  const getIsCampaignPlatformCreated = (platform) => {
    const state = states?.[platform];
    return state !== ADS_CAMPAIGN_STATUS_DRAFT;
  };
  const getShowActionsPlatform = (platform) => {
    const isCampaignPlatformCreated = getIsCampaignPlatformCreated(platform);
    const state = states?.[platform];

    return (
      isCampaignPlatformCreated &&
      state &&
      state !== ADS_CAMPAIGN_STATUS_DRAFT &&
      state !== ADS_CAMPAIGN_STATUS_FINISHED
    );
  };
  const getIsGeneralCampaignIncompatible = () => {
    let allCampaignsIncompatible = true;

    platforms.forEach((platform) => {
      const isIncompatible = getValues(
        `platformsData.${platform}.isIncompatible`
      );
      if (!isIncompatible) {
        allCampaignsIncompatible = false;
      }
    });

    return allCampaignsIncompatible;
  };

  const getIsPlatformOptionDisabled = (platformKey) =>
    Boolean(generatedPlatforms?.[platformKey]);

  useEffect(() => {
    // A second run for the same campaign (strict mode, or a param identity
    // that did not change the id) must not wipe adsGroups while the editor
    // is still showing the previously selected ad group.
    if (
      campaignIDParam &&
      lastInitialLoadCampaignIDRef.current === campaignIDParam
    ) {
      return;
    }

    setIsLoading(true);
    reset({
      context: "",
      language: "",
      locations: {
        contexts: [],
        locations: [],
      },
      platforms: [],
      adsGroups: [],
    });
    setCreativeOptimizations({});
    setStatistics({});
    setIsLoadingStatistics(false);
    if (campaignIDParam) {
      lastInitialLoadCampaignIDRef.current = campaignIDParam;
      setCampaignID(campaignIDParam);

      const pendingGeneration = consumePendingInitialGenerationState(
        location.state
      );
      if (
        pendingGeneration?.campaignID === campaignIDParam &&
        pendingGeneration.platformData
      ) {
        const setupFields = pendingGeneration.setupFields || {};
        if (setupFields.context) {
          setValue("context", setupFields.context);
        }
        if (setupFields.language) {
          setValue("language", setupFields.language);
        }
        if (hasCampaignLocations(setupFields.locations)) {
          setValue("locations", setupFields.locations);
        }
        if (setupFields.attachmentsFiles) {
          setValue("attachmentsFiles", setupFields.attachmentsFiles);
        }
        if (setupFields.fileNamesMapping) {
          setValue("fileNamesMapping", setupFields.fileNamesMapping);
        }

        pendingInitialGenerationRef.current = pendingGeneration;
        setPlatformGenerating(pendingGeneration.platformData.platform);
        setIsLoading(false);
        getBrandInformation(false);
        navigate(
          buildCreateCampaignEditorUrl({ campaignID: campaignIDParam }),
          {
            replace: true,
            state: {},
          }
        );
        return;
      }

      onGetInitialData(campaignIDParam);
      return;
    }

    lastInitialLoadCampaignIDRef.current = null;
    const currentParams = new URLSearchParams(window.location.search);
    const initialCreatives = currentParams.get("initialCreatives");
    navigate(buildCreateCampaignListUrl({ initialCreatives }), {
      replace: true,
    });

    // eslint-disable-next-line
  }, [campaignIDParam]);

  useEffect(() => {
    const pendingGeneration = pendingInitialGenerationRef.current;
    if (
      !pendingGeneration?.platformData ||
      campaignID !== pendingGeneration.campaignID
    ) {
      return;
    }

    pendingInitialGenerationRef.current = null;
    generateCampaignPlatformRef.current?.(pendingGeneration.platformData);
  }, [campaignID]);

  useEffect(() => {
    if (!isSyncingData) {
      setIsPlatformClicked(false);
    }
  }, [isSyncingData]);

  useEffect(() => {
    function handleInitialized() {
      setSchema(
        getCampaignSchema({ ...brandInformation, integrations, currencyTaxes })
      );
    }

    if (i18next.isInitialized) {
      setSchema(
        getCampaignSchema({ ...brandInformation, integrations, currencyTaxes })
      );
    } else {
      i18next.on("initialized", handleInitialized);
    }

    return () => {
      i18next.off("initialized", handleInitialized);
    };
  }, [brandInformation, integrations, currencyTaxes]);

  useEffect(() => {
    const platformsData = getValues("platformsData");
    if (_.isEmpty(platformsData)) return;
    onUpdateCurrencyTaxPlatforms(platformsData);

    // eslint-disable-next-line
  }, [platformsDepKey]);

  useEffect(() => {
    const expiresAt = Number(campaignActionLock?.expiresAt);
    const msToExpire = expiresAt - Date.now();

    if (!campaignActionLock?.status || !(msToExpire > 0)) {
      setCampaignActionStatus(null);
      return;
    }

    setCampaignActionStatus(campaignActionLock.status);
    const timeoutID = setTimeout(
      () => setCampaignActionStatus(null),
      msToExpire
    );
    return () => clearTimeout(timeoutID);
  }, [campaignActionLock]);

  useEffect(() => {
    return () => {
      if (adsCampaignActionStatusListener) {
        dispatch(
          stopListenerAdsCampaignActionStatus(adsCampaignActionStatusListener)
        );
      }
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!campaignID) return;

    onChangeSectionSelected({
      platform: platformParam || undefined,
      assetsGroupID: assetsGroupIDParam || undefined,
      adGroupID: adGroupIDParam || undefined,
      adID: adIDParam || undefined,
    });
    // eslint-disable-next-line
  }, [platformParam, assetsGroupIDParam, adGroupIDParam, adIDParam]);

  useEffect(() => {
    if (!campaignID) return;

    const items = pendingIntegrationFormSync?.items || [];
    if (!Array.isArray(items) || items.length === 0) return;

    const matching = items.filter((item) => item.campaignID === campaignID);
    if (matching.length === 0) return;

    matching.forEach(({ platform, integrationID }) => {
      if (platform == null || platform === "") return;
      if (integrationID == null || integrationID === "") return;
      setValue(`platformsData.${platform}.integrationID`, integrationID, {
        shouldValidate: true,
        shouldDirty: true,
      });
    });
    onChangeSectionSelected(sectionSelected);
    dispatch(consumePendingIntegrationFormSyncForCampaign(campaignID));

    // eslint-disable-next-line
  }, [campaignID, pendingIntegrationFormSync, setValue]);

  const onListenerCampaignApproval = async (nextCampaignID) => {
    if (campaignApprovalListener) {
      await dispatch(stopListenerCampaignApproval(campaignApprovalListener));
    }

    if (!nextCampaignID) {
      setCampaignApproval(normalizeCampaignApprovalState(null));
      setCampaignApprovalListener(null);
      return;
    }

    dispatch(
      startListenerCampaignApproval({
        campaignID: nextCampaignID,
        onReferenceAvailable: (listener) =>
          setCampaignApprovalListener(listener),
        onUpdatedDataCallback: (approvalData) => {
          setCampaignApproval(approvalData);
        },
      })
    );
  };

  useEffect(() => {
    onListenerCampaignApproval(campaignID);

    return () => {
      if (campaignApprovalListener) {
        dispatch(stopListenerCampaignApproval(campaignApprovalListener));
      }
    };
    // eslint-disable-next-line
  }, [campaignID]);

  useEffect(() => {
    const previousStatus = previousApprovalStatusRef.current;
    const nextStatus = deriveApprovalStatusFromReviewers({
      reviewers: campaignApproval?.reviewers,
      fallbackStatus: campaignApproval?.status,
    });

    if (previousStatus !== "rejected" && nextStatus === "rejected") {
      setIsApprovalCommentsPanelOpen(false);
    }

    previousApprovalStatusRef.current = nextStatus;
  }, [campaignApproval?.status, campaignApproval?.reviewers]);

  // Establecer visibilidad del chat basado en el tamaño de pantalla
  useEffect(() => {
    setIsChatVisible(isLargeScreen);
  }, [isLargeScreen]);

  // Funciones para controlar la visibilidad del chat
  const handleOpenChat = () => {
    setIsChatVisible(true);
  };

  const onCloseChat = () => {
    setIsChatVisible(false);
  };

  const onResetChat = () => {
    setValue("report", {});
  };

  const handleToggleChat = () => {
    setIsChatVisible(!isChatVisible);
  };

  const levelSectionSelected = onGetItemSelectedLevel({
    platform: sectionSelected.platform,
    assetsGroupID: sectionSelected.assetsGroupID,
    adGroupID: sectionSelected.adGroupID,
    adID: sectionSelected.adID,
  });

  const isGeneralCampaignIncompatible = getIsGeneralCampaignIncompatible();
  const isGeneralCampaignActivated = getIsCampaignPlatformActive("general");
  const isGeneralCampaignCreated = getIsCampaignPlatformCreated("general");
  const canEditCampaign = dispatch(getRoleCapability("canEditCampaign"));
  const isGeneralDisabledFields =
    !canEditCampaign || isGeneralCampaignIncompatible || isSyncingData;

  const isAllCampaignsPlatformCreated =
    platforms.length > 0 &&
    !platforms?.some((platform) => !platformIDs?.[platform]);

  if (isLoading) {
    return (
      <Loader fullWidth hasMessage={true} message={t(LOADING_INFORMATION)} />
    );
  }
  return (
    <Box
      onClick={() => setIsPlatformClicked(true)}
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        height: { xs: "auto", md: `calc(100vh - ${totalTopOffsetPx}px)` },
        minHeight: { xs: "100vh", md: "auto" },
        overflowX: { xs: "hidden", md: "visible" },
        overflowY: { xs: "auto", md: "initial" },
      }}
    >
      <Helmet>
        <title>{`${theme.nameBusiness} - Campaign`}</title>
      </Helmet>
      <FormProvider
        {...methods}
        campaignID={campaignID}
        onGenerateCampaignPlatform={onGenerateCampaignPlatform}
        platformGenerating={platformGenerating}
        isGenerating={Boolean(platformGenerating)}
        isSyncingData={isSyncingData}
        sectionSelected={sectionSelected}
        onChangeSectionSelected={onChangeSectionSelected}
        levelSectionSelected={levelSectionSelected}
        onGetItemSelectedLevel={onGetItemSelectedLevel}
        isGeneralCampaignActivated={isGeneralCampaignActivated}
        isGeneralCampaignCreated={isGeneralCampaignCreated}
        isGeneralDisabledFields={isGeneralDisabledFields}
        isGeneralCampaignIncompatible={isGeneralCampaignIncompatible}
        getIsCampaignPlatformCreated={getIsCampaignPlatformCreated}
        getIsCampaignPlatformActive={getIsCampaignPlatformActive}
        hasSomePlatformDraft={hasSomePlatformDraft}
        hasSomePlatformCreated={hasSomePlatformCreated}
        onChangeDataModalErrorsCampaigns={setDataModalErrorsCampaigns}
        onChangeModalErrorsCampaignsOpen={setModalErrorsCampaignsOpen}
        onChangeStatusCampaign={onChangeStatusCampaign}
        getShowActionsPlatform={getShowActionsPlatform}
        showErrorGenerating={showErrorGenerating}
        lastInformationToGenerate={lastInformationToGenerate}
        isUpdating={isUpdating}
        onChangeIsUpdating={setIsUpdating}
        isAllCampaignsPlatformCreated={isAllCampaignsPlatformCreated}
        isForcedSetupPage={isForcedSetupPage}
        onChangeIsForcedSetupPage={setIsForcedSetupPage}
        brandInformation={brandInformation}
        statistics={statistics}
        previewsCached={previewsCached}
        onChangePreviewsCached={setPreviewsCached}
        audiencePreviewsCache={audiencePreviewsCache}
        onChangeAudiencePreviewsCache={setAudiencePreviewsCache}
        onChangeStatistics={setStatistics}
        isLoadingStatistics={isLoadingStatistics}
        onChangeIsLoadingStatistics={setIsLoadingStatistics}
        currencyTaxes={currencyTaxes}
        setCurrencyTaxes={setCurrencyTaxes}
        dateFiltersForm={methodsDateFilters}
        campaignActionStatus={campaignActionStatus}
        campaignApproval={campaignApproval}
        isEnablingCampaignApproval={isEnablingCampaignApproval}
        onEnableCampaignApproval={onEnableCampaignApproval}
        onCopyCampaignApprovalLink={onCopyCampaignApprovalLink}
        onOpenCampaignApprovalCommentsPanel={
          onOpenCampaignApprovalCommentsPanel
        }
        onSaveAdsCampaignDraftWithApproval={(payload) =>
          dispatch(startSaveAdsCampaignWithApproval(payload))
        }
        optimizations={optimizations}
        onChangeOptimizations={setOptimizations}
        chatMessages={chatMessages}
        isLoadingChatMessages={isLoadingChatMessages}
        hasMoreChatMessages={hasMoreChatMessages}
        onLoadOlderChatMessages={onLoadOlderChatMessages}
        onChangeChatMessages={setChatMessages}
        shouldOpenChat={shouldOpenChat}
        onChangeShouldOpenChat={setShouldOpenChat}
        isChatVisible={isChatVisible}
        pendingAgentChangesCount={pendingAgentChangesCount}
        onChangeIsChatVisible={setIsChatVisible}
        onOpenChat={handleOpenChat}
        onCloseChat={onCloseChat}
        onToggleChat={handleToggleChat}
        isViewOnboarding={isViewOnboarding}
        getIsPlatformOptionDisabled={getIsPlatformOptionDisabled}
        clearPreloadedChatMessagesRef={clearPreloadedChatMessagesRef}
        creativeOptimizations={creativeOptimizations}
        onUpsertCreativeOptimization={onUpsertCreativeOptimization}
        onRemoveCreativeOptimization={onRemoveCreativeOptimization}
        isPlatformClicked={isPlatformClicked}
      >
        <ApprovalCommentFieldHintProvider>
          {isMobile && isViewOnboarding && platforms.length === 0 && (
            <SlideMenu hideMobileFooter={false} />
          )}
          {!isViewOnboarding && platforms.length > 0 && <Sidebar />}
          <GeneralContainer />

          {!isViewOnboarding && (
            <SlideChat
              isVisible={isChatVisible}
              onCloseChat={onCloseChat}
              onResetChat={onResetChat}
              onChangePendingAgentChangesCount={setPendingAgentChangesCount}
              onRegisterClearPreloadedMessages={(fn) =>
                (clearPreloadedChatMessagesRef.current = fn)
              }
            />
          )}
          <FloatingValidationErrorsPanel />
          {!isViewOnboarding &&
          campaignApproval?.enabled &&
          isApprovalCommentsPanelOpen ? (
            <CampaignApprovalPanel
              approvalData={campaignApproval}
              onChangeSectionSelected={onChangeSectionSelected}
              onClosePanel={() => setIsApprovalCommentsPanelOpen(false)}
            />
          ) : null}
          <ApprovalEnableSuccessDialog
            modalOpen={approvalSuccessDialog.open}
            onCloseModal={() =>
              setApprovalSuccessDialog((prev) => ({ ...prev, open: false }))
            }
            approvalType="campaign"
            approvalUrl={approvalSuccessDialog.approvalUrl}
            approvalID={campaignID}
            reviewerID={approvalSuccessDialog.reviewerID}
          />
          {modalErrorsCampaignsOpen && (
            <ModalErrorsCampaigns
              modalOpen={modalErrorsCampaignsOpen}
              onCloseModal={() => setModalErrorsCampaignsOpen(false)}
              campaign={getValues()}
              successCampaigns={dataModalErrorsCampaigns.successCampaigns}
              failedCampaigns={dataModalErrorsCampaigns.failedCampaigns}
              errors={dataModalErrorsCampaigns.errors}
            />
          )}
        </ApprovalCommentFieldHintProvider>
      </FormProvider>
    </Box>
  );
};

export default NewAdsCampaign;
